import { Outlet, useOutletContext } from "react-router-dom";

import { useIsSidebarLayout } from "src/hooks/useIsSidebarLayout";
import { DashboardContent } from "src/layout/DashboardContent";
import { LayoutHeader } from "src/layout/Header";
import { MainSideBar } from "src/mainPage/MainSideBar";

export const MainPageDashboard: React.FC = () => {
  const context = useOutletContext();
  const isSideBarEnabled = useIsSidebarLayout();

  return (
    <DashboardContent
      Header={!isSideBarEnabled && <LayoutHeader border />}
      sidebar={isSideBarEnabled && <MainSideBar />}
      removePadding
    >
      <Outlet context={context} />
    </DashboardContent>
  );
};
